// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__h6OvR","log":"ModalInventoryLogs_log__3j750","date":"ModalInventoryLogs_date__3xZjU","userName":"ModalInventoryLogs_userName__2ecaE"};